import api from './api';

const openaiUsageService = {
  // Obtener uso de hoy
  getCurrentUsage: async () => {
    try {
      const response = await api.get('/api/OpenAIUsage/current');
      return response.data;
    } catch (error) {
      console.error('Error al obtener uso actual:', error);
      throw error;
    }
  },

  // Obtener uso del mes
  getMonthlyUsage: async () => {
    try {
      const response = await api.get('/api/OpenAIUsage/monthly');
      return response.data;
    } catch (error) {
      console.error('Error al obtener uso mensual:', error);
      throw error;
    }
  },

  // Obtener uso entre fechas
  getRangeUsage: async (startDate, endDate) => {
    try {
      const response = await api.get('/api/OpenAIUsage/range', {
        params: {
          startDate,
          endDate
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener uso por rango:', error);
      throw error;
    }
  },

  // Obtener resumen rápido
  getSummary: async () => {
    try {
      const response = await api.get('/api/OpenAIUsage/summary');
      return response.data;
    } catch (error) {
      console.error('Error al obtener resumen:', error);
      throw error;
    }
  },

  // Obtener tasa de cambio USD/COP
  getExchangeRate: async () => {
    try {
      const response = await api.get('/api/OpenAIUsage/exchange-rate');
      return response.data;
    } catch (error) {
      console.error('Error al obtener tasa de cambio:', error);
      throw error;
    }
  }
};

export default openaiUsageService;
